import api from './api';

export const erstpruefungService = {
  /**
   * Upload an Erstprüfung PDF — sends to be-pdf which proxies to pdf-processor
   * and saves the extracted data in the Asphalt MongoDB database.
   */
  async upload(file) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post('/api/erstpruefungen/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 120000 // 2 min for processing
      });

      return response.data;
    } catch (error) {
      console.error('Error uploading Erstprüfung:', error);
      throw error;
    }
  },

  /**
   * Get all Erstprüfungen from the Asphalt database.
   */
  async getAll() {
    try {
      const response = await api.get('/api/erstpruefungen');
      return response.data;
    } catch (error) {
      console.error('Error fetching Erstprüfungen:', error);
      throw error;
    }
  },

  /**
   * Get a single Erstprüfung by ID.
   */
  async getById(id) {
    try {
      const response = await api.get(`/api/erstpruefungen/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching Erstprüfung:', error);
      throw error;
    }
  },

  /**
   * Delete an Erstprüfung by ID.
   */
  async delete(id) {
    try {
      const response = await api.delete(`/api/erstpruefungen/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting Erstprüfung:', error);
      throw error;
    }
  }
};
